import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { AdminOnlyRoute } from '@/components/admin-only-route'
import CompetitionForm from '@/components/forms/competition-form'
import PageLayout from '@/components/layout/page-layout'
import { useSetSidebarSubLabel } from '@/contexts/sidebar-sub-label-context'

export const Route = createFileRoute('/_authenticated/competitions/new')({
  component: () => (
    <AdminOnlyRoute>
      <NewCompetitionPage />
    </AdminOnlyRoute>
  ),
})

function NewCompetitionPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  useSetSidebarSubLabel('/competitions/new', t('competitionsPage.createTitle'))

  return (
    <PageLayout title={t('competitionsPage.createTitle')}>
      <CompetitionForm onSuccess={() => navigate({ to: '/competitions' })} />
    </PageLayout>
  )
}
